module.exports = __webpack_public_path__ + "img/browser-firefox-logo.1a1fff5a.png";